import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LatteIcon } from '../common';

const BlogHeader = () => {
  const navigate = useNavigate();

  return (
    <header className="header relative">
      <div className="header-container">
        <div className="header-left">
          <div className="header-logo">
            <LatteIcon size="lg" />
            <button 
              onClick={() => navigate('/')}
              className="header-title"
              title="메인 페이지로 이동"
            >
              Latte is
            </button>
          </div>
          <span className="header-separator hidden sm:inline">|</span>
          <span className="text-lg hidden sm:inline" style={{ color: 'var(--color-text-tertiary)' }}>
            Blog
          </span>
        </div>
        
        {/* 블로그 헤더는 우측 메뉴 없음 - 심플하게 유지 */}
        <div className="header-right hidden lg:flex">
          {/* 높이를 맞추기 위한 더미 요소 - Header.js의 버튼들과 동일한 높이 확보 */}
          <div className="h-10" aria-hidden="true"></div>
        </div>
      </div>
    </header>
  );
};

export default BlogHeader;
